import { createAsyncThunk } from '@reduxjs/toolkit'

import { api, createRequestSlice } from 'utils'
import {
    CreateJobOpeningRequest,
    ListJobOpeningsResponse,
    PartialUpdateJobOpeningRequest,
} from 'types/swagger'
import { RootState } from 'store'

import { showErrorNotification } from '../../notifications/notificationsSlice'
import { Job } from './types'

export type Slugs = { eventSlug: string, boothSlug: string }

interface CreateJobProps extends Slugs {
    data: CreateJobOpeningRequest
}

interface UpdateJobProps extends Slugs {
    data: PartialUpdateJobOpeningRequest
    id: number
}

export const createJob = createAsyncThunk(
    'createJob',
    async (args: CreateJobProps, thunkAPI) => {
        const { data, eventSlug, boothSlug } = args
        const url = `/events/${eventSlug}/organizer/booths/${boothSlug}/jobs/`
        const reponse = await api.safePost(url, data)
        if (reponse.error) {
            thunkAPI.dispatch(showErrorNotification(reponse.error))
        } else {
            thunkAPI.dispatch(fetchJobs(args))
        }
    },
)

export const updateJob = createAsyncThunk(
    'updateJob',
    async (args: UpdateJobProps, thunkAPI) => {
        const {
            data, eventSlug, boothSlug, id
        } = args
        const url = `/events/${eventSlug}/organizer/booths/${boothSlug}/jobs/${id}/`
        const reponse = await api.safePatch(url, data)
        if (reponse.error) {
            thunkAPI.dispatch(showErrorNotification(reponse.error))
        } else {
            thunkAPI.dispatch(fetchJobs(args))
        }
    },
)

export const deleteJob = createAsyncThunk(
    'deleteJobs',
    async (args: { job: Job } & Slugs, thunkAPI) => {
        const { eventSlug, boothSlug } = args
        const id = args.job.id
        const url = `events/${eventSlug}/organizer/booths/${boothSlug}/jobs/${id}/`
        await api.delete(url)
        thunkAPI.dispatch(fetchJobs(args))
    },
)

export const fetchJobs = createAsyncThunk(
    'fetchJobs',
    async ({ eventSlug, boothSlug }: Slugs) => {
        const url = `events/${eventSlug}/organizer/booths/${boothSlug}/jobs/`
        const response: ListJobOpeningsResponse = await api.get(url)
        return response
    },
)

const jobsSlice = createRequestSlice<ListJobOpeningsResponse>(fetchJobs, 'fetchJobsSlice')
export const selectJobs = (state: RootState) => state.booth.jobs.data?.results || []
export default jobsSlice.reducer
